export const getTimezone = (timezone: string | undefined) => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (ignore) {
    return timezone ?? ''
  }
}
